import { render } from "./Footer.vue?vue&type=template&id=103583f0&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=103583f0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-103583f0"

export default script